export default "__VITE_ASSET__50868be0__"